import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QueueMessage } from "../typeDefs/queueManagement";

export interface VtsState {
    key: string;
    secret: string;
    loading: boolean;
    credsValid: boolean;
    logs: QueueMessage[];
    mostRecentRun: Date | null;
}

const initialState: VtsState = {
    key: "",
    secret: "",
    loading: false,
    credsValid: false,
    logs: [],
    mostRecentRun: null,
};

export const vtsSlice = createSlice({
    name: "vts",
    initialState,
    reducers: {
        setKey: (state, action: PayloadAction<string>) => {
            state.key = action.payload;
        },
        setSecret: (state, action: PayloadAction<string>) => {
            state.secret = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setMessages: (state, action: PayloadAction<QueueMessage[]>) => {
            state.logs = action.payload;
        },
        setMostRecentRun: (state, action: PayloadAction<Date | null>) => {
            state.mostRecentRun = action.payload;
        },
        setCredsValid: (state, action: PayloadAction<boolean>) => {
            state.credsValid = action.payload;
        },
    },
});

export const {
    setKey,
    setSecret,
    setLoading,
    setMessages,
    setMostRecentRun,
    setCredsValid,
} = vtsSlice.actions;

export default vtsSlice.reducer;
